import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {
  findAdminNavigationItem,
  getAdminSiblingItems,
  shouldShowAdminBreadcrumb,
} from 'utils/adminNavigation';
import styles from './style.module.scss';

const AdminBreadcrumb = ({ pathname }) => {
  const [anchorElement, setAnchorElement] = React.useState(null);
  const currentItem = findAdminNavigationItem(pathname);
  const siblingItems = getAdminSiblingItems(pathname);

  if (!shouldShowAdminBreadcrumb(pathname)) {
    return null;
  }

  const handleOpenMenu = (event) => {
    setAnchorElement(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElement(null);
  };

  return (
    <div className={`wdn-band ${styles['breadcrumb-band']}`}>
      <div className="wdn-inner-wrapper">
        <nav aria-label="Admin breadcrumb" className={styles['breadcrumb-nav']}>
          <ol className={styles['breadcrumb-list']}>
            <li className={styles['breadcrumb-item']}>
              <Link to="/admin" className={styles['breadcrumb-link']}>
                Admin
              </Link>
            </li>
            <li aria-hidden="true" className={styles['breadcrumb-divider']}>
              /
            </li>
            <li className={styles['breadcrumb-item']}>
              <span className={styles['group-label']}>
                {currentItem.groupLabel}
              </span>
            </li>
            <li aria-hidden="true" className={styles['breadcrumb-divider']}>
              /
            </li>
            <li className={styles['breadcrumb-item']}>
              {siblingItems.length > 0 ? (
                <>
                  <Button
                    className={styles['current-page-button']}
                    onClick={handleOpenMenu}
                    endIcon={<ArrowDropDownIcon fontSize="small" />}
                    aria-label="Switch to another page in this section"
                    aria-controls="admin-breadcrumb-menu"
                    aria-haspopup="menu"
                    style={{ textTransform: 'none' }}
                  >
                    {currentItem.label}
                  </Button>
                  <Menu
                    id="admin-breadcrumb-menu"
                    anchorEl={anchorElement}
                    keepMounted
                    open={Boolean(anchorElement)}
                    onClose={handleCloseMenu}
                  >
                    {siblingItems.map((item) => (
                      <MenuItem
                        key={item.path}
                        component={Link}
                        to={item.path}
                        className={styles['menu-item']}
                        onClick={handleCloseMenu}
                        aria-disabled={item.disabled}
                        disabled={item.disabled}
                      >
                        {item.label}
                      </MenuItem>
                    ))}
                  </Menu>
                </>
              ) : (
                <span className={styles['current-page-label']}>
                  {currentItem.label}
                </span>
              )}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
};

AdminBreadcrumb.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default AdminBreadcrumb;
